<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <validated-text-field
        v-model="user.first_name"
        field-name="first_name"
        rules="required"
        type="text"
      />
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
      <validated-text-field
        v-model="user.last_name"
        field-name="last_name"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <validated-text-field
        v-model="user.birth_date"
        field-name="birth_date"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <validated-text-field
        v-model="user.birth_place"
        field-name="birth_place"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col
      cols="12"
      md="4"
    >
      <validated-text-field
        v-model="user.mother_name"
        field-name="mother_name"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <validated-text-field
        v-model="user.phone"
        field-name="phone"
        rules=""
        type="text"
      />
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <validated-text-field
        v-model="user.mobile"
        field-name="mobile"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col cols="12">
      <validated-text-field
        v-model="user.address"
        field-name="address"
        rules="required"
        type="text"
      />
    </v-col>

    <v-col cols="12">
      <validated-text-field
        v-model="user.email"
        field-name="email"
        rules="required"
        type="text"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'UserBase',
    props: {
      user: {
        type: Object,
        default () {
          return {
            first_name: '',
            last_name: '',
            birth_date: '',
            birth_place: '',
            mother_name: '',
            phone: '',
            mobile: '',
            address: '',
            email: '',
          }
        },
      },
    },
  }
</script>
